import { useState } from 'react';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const FilterDropdown = ({ data, handleItemClick }) => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [isOpen, setIsOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
    const { t } = useTranslation();

  return (
    <div className=" items-center justify-center py-4 relative">
      <button
        id="dropdownDefault"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-white bg-customgreen hover:bg-primary-800  focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-4 py-2.5 transition-all"
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <FilterAltIcon />
        {t('Filter')}
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          aria-hidden="true"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>

      {isOpen && (
        <div
          className={`absolute  top-16 z-10 w-56 p-3 bg-white rounded-lg mt-2 shadow-lg transition-all duration-500 ease-in-out transform ${
            isOpen
              ? 'opacity-100 scale-100 translate-y-0'
              : 'opacity-0 scale-95 translate-y-[-10px] pointer-events-none'
          }`}
        >
          <h6 className="mb-3 text-sm text-gray-900 font-semibold">{t("Search by Title")}</h6>
          <hr className="mb-2" />
          <ul className="space-y-2 text-sm h-40 overflow-y-auto">
            <li
              className={`flex items-center py-2 px-3 mx-1 rounded-md cursor-pointer transition-all ${
                activeItem === null ? 'bg-customgreen text-white' : 'hover:bg-green-50 hover:text-customgreen'
              }`}
              onClick={() => {
                handleItemClick(), setActiveItem(null);
              }}
            >
              <label className="text-sm font-medium">{t('All')}</label>
            </li>
            {data?.map((item, index) => (
              <li
                key={index}
                className={`flex items-center py-2 px-3 mx-1 rounded-md cursor-pointer transition-all ${
                  activeItem === item?.photoGalleryID
                    ? 'bg-customgreen text-white'
                    : 'hover:bg-green-50 hover:text-customgreen'
                }`}
                onClick={() => {
                  handleItemClick(item?.photoGalleryID), setActiveItem(item?.photoGalleryID);
                }}
              >
                <label className="text-sm font-medium">{isActive ? item?.title : item?.titleEn}</label>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FilterDropdown;
